import { apiClient } from './api';

export interface KeywordEffectiveness {
  keyword: string;
  frequency: number;
  avgScoreWith: number;
  avgScoreWithout: number;
  effectiveness: number;
  confidence: 'high' | 'medium' | 'low';
  topRoles: string[];
}

export interface KeywordEffectivenessResponse {
  keywords: KeywordEffectiveness[];
  totalAnalyses: number;
  lastUpdated: string;
  dataWindow: string;
}

export const statsService = {
  async getKeywords(limit = 15): Promise<KeywordEffectivenessResponse> {
    const { data } = await apiClient.get<{ data: KeywordEffectivenessResponse }>(
      `/api/v1/stats/keywords`,
      { params: { limit } }
    );
    return data.data;
  },
};
